import { useTranslation } from 'react-i18next';

import CardContentWrapper from '../card-content-wrapper/CardContentWrapper';

import TopPromotionCard from './TopPromotionCard';

import Carousel from 'components/custom/carousel/Carousel';
import { CarouselVariant } from 'components/custom/carousel/types';
import { BaseCardContent, CtaContent } from 'utils/models';
import { renderRichText } from 'utils/rich-text-render';

import './IntroSectionCardDisplay.scss';

type IntroSectionCardDisplayProps = {
  title?: string;
  preamble?: any;
  cta?: CtaContent;
  backgroundColor?: string;
  titleCentered?: boolean;
  isCarousel?: boolean;
  items: BaseCardContent[];
};

const IntroSectionCardDisplay = ({
  title,
  preamble,
  cta,
  items,
  backgroundColor = '#FFFFFF',
  titleCentered = false,
  isCarousel = false,
}: IntroSectionCardDisplayProps) => {
  const { t } = useTranslation();
  return (
    <section className="intro-section-wrapper" style={{ backgroundColor: backgroundColor }}>
      <CardContentWrapper
        title={title}
        preamble={preamble ? renderRichText(preamble.json) : undefined}
        cta={cta}
        isTitleCentered={titleCentered}
        titleVariant={titleCentered ? 'display-25' : 'title-300'}
      >
        <section>
          {isCarousel && (
            <Carousel variant={CarouselVariant.LARGE}>
              {items.map((item) => (
                <TopPromotionCard
                  key={item.title}
                  title={item.title}
                  preamble={item.body ?? <></>}
                  cta={{
                    url: item.url,
                    text: item.tagline ?? t('read_more'),
                  }}
                  image={item.image}
                />
              ))}
            </Carousel>
          )}
          {!isCarousel && (
            <div className="intro-section-card-wrapper">
              {items.map((item) => (
                <TopPromotionCard
                  key={item.title}
                  title={item.title}
                  preamble={item.body ?? <></>}
                  cta={{
                    url: item.url,
                    text: item.tagline ?? t('read_more'),
                  }}
                  image={item.image}
                />
              ))}
            </div>
          )}
        </section>
      </CardContentWrapper>
    </section>
  );
};

export default IntroSectionCardDisplay;
